import lazyLoad from '../../../../Utils/lazyLoad';

const Start = lazyLoad(() => import('../Start'));

export default () => {
  return <Start />;
};
